export const ALERT_COLOR_PRESETS = [
  { value: '#ffbc34', label: 'Amber' },
  { value: '#ef6e6e', label: 'Red' },
  { value: '#22c6ab', label: 'Green' },
  { value: '#4798e8', label: 'Blue' },
  { value: '#7460ee', label: 'Purple' },
  { value: '#26c6da', label: 'Cyan' },
  { value: '#6c757d', label: 'Gray' },
  { value: '#343a40', label: 'Dark' },
]

export const ALERT_ICON_OPTIONS = [
  { value: 'bell', label: 'Bell' },
  { value: 'exclamation-triangle', label: 'Warning' },
  { value: 'bullhorn', label: 'Bullhorn' },
  { value: 'broadcast-tower', label: 'Broadcast' },
  { value: 'microphone', label: 'Mic' },
  { value: 'microphone-slash', label: 'Mic off' },
  { value: 'play', label: 'Play' },
  { value: 'pause', label: 'Pause' },
  { value: 'hand-paper', label: 'Hold' },
  { value: 'check', label: 'Check' },
]

export const DEFAULT_ALERT_SHORTCUTS = [
  { label: 'Standby', message: 'Standby', color: '#ffbc34', icon: 'hand-paper' },
  { label: 'Go live sekarang', message: 'Go live sekarang', color: '#ef6e6e', icon: 'broadcast-tower' },
  { label: 'Hold — tunggu cue', message: 'Hold — tunggu cue', color: '#4798e8', icon: 'pause' },
  { label: 'Mic on', message: 'Mic on', color: '#22c6ab', icon: 'microphone' },
  { label: 'Mic off', message: 'Mic off', color: '#6c757d', icon: 'microphone-slash' },
]

export function normalizeAlertShortcuts(raw) {
  if (!Array.isArray(raw)) {
    if (typeof raw === 'string') {
      return raw
        .split('\n')
        .map((s) => s.trim())
        .filter(Boolean)
        .map((label) => ({ label, message: label, color: '#ffbc34', icon: 'bell' }))
    }
    return []
  }
  return raw
    .map((item) => {
      if (typeof item === 'string') {
        const label = item.trim()
        if (!label) return null
        return { label, message: label, color: '#ffbc34', icon: 'bell' }
      }
      if (!item || typeof item !== 'object') return null
      const label = String(item.label || item.message || '').trim()
      if (!label) return null
      return {
        label,
        message: String(item.message || label).trim() || label,
        color: normalizeColor(item.color),
        icon: String(item.icon || 'bell').replace(/^fa-/, '') || 'bell',
      }
    })
    .filter(Boolean)
}

export function normalizeColor(color) {
  const c = String(color || '').trim()
  if (/^#[0-9a-fA-F]{6}$/.test(c)) return c.toLowerCase()
  if (/^#[0-9a-fA-F]{3}$/.test(c)) {
    return `#${c[1]}${c[1]}${c[2]}${c[2]}${c[3]}${c[3]}`.toLowerCase()
  }
  return '#ffbc34'
}

export function contrastText(hex) {
  const c = normalizeColor(hex).slice(1)
  const r = parseInt(c.slice(0, 2), 16)
  const g = parseInt(c.slice(2, 4), 16)
  const b = parseInt(c.slice(4, 6), 16)
  const luma = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luma > 0.62 ? '#1a1a1a' : '#ffffff'
}

export function blankAlertShortcut() {
  return { label: '', message: '', color: '#ffbc34', icon: 'bell' }
}
